<template>
  <div>
    <button
      class="flex items-center px-3 py-2 space-x-3 text-sm tracking-wider text-white uppercase transition duration-200 rounded-md cursor-pointer "
      :class="
        value
          ? 'bg-brand-500 hover:bg-brand-400'
          : 'bg-gray-400 hover:bg-gray-500'
      "
      @click="action"
    >
      <p>
        {{ locales[lang].only_available }}
      </p>
      <div class="relative w-8">
        <div
          class="
            transform
            transition-all
            duration-200
            absolute
            top-0
            left-0
            z-10
            w-4
            h-4
            -mt-1.5
            text-xs
            bg-white
            rounded-full
            shadow-lg
          "
          :class="value ? '' : 'translate-x-full'"
        />
        <div class="h-1 bg-white rounded-lg opacity-50" />
      </div>
    </button>
  </div>
</template>

<script>
import bus from "../js/bus.js";

export default {
  props: ["lang", "locales"],
  data() {
    return {
      value: false,
    };
  },
  mounted() {
    bus.$on("updateData", (item) => {
      if (item.id === "status") {
        this.value = item.data;
      }
    });
  },
  methods: {
    action() {
      this.value = !this.value;
      this.edited();
    },
    edited() {
      bus.$emit("setData", {
        id: "status",
        data: this.value,
      });
    },
  },
};
</script>

